function loadItems(button) {
  // Restrict to inputs: collection grids use data-total-pages on the wrapper
  // div too; div.value is undefined so parseInt becomes NaN and .finally never runs.
  const totalPagesEl = document.querySelector("input[data-total-pages]");
  const currentPageEl = document.querySelector("input[data-current-page]");
  const nextUrlEl = document.querySelector("input[data-next-url]");
  if (!totalPagesEl || !currentPageEl || !nextUrlEl) return;

  const totalPages = parseInt(totalPagesEl.value, 10);
  let currentPage = parseInt(currentPageEl.value, 10);
  currentPage = currentPage + 1;

  const rawValue = nextUrlEl.value;

  const getUrlWithoutPhcursor = (value, pageValue) => {
    const url = new URL(value, window.location.origin);
    url.searchParams.set("page", pageValue);
    url.searchParams.delete("phcursor");
    return url.pathname + "?" + url.searchParams.toString();
  };

  const nextUrl = getUrlWithoutPhcursor(rawValue, currentPage);

  currentPageEl.value = currentPage;

  button.setAttribute("disabled", "");
  button.classList.add("loading");

  fetch(nextUrl)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.text();
    })
    .then((responseHTML) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(responseHTML, "text/html");
      const newGrid = doc.querySelector(".load-more-grid");
      const wrapper = document.querySelector(".load-more-grid");
      if (!newGrid || !wrapper) {
        throw new Error("Grid element not found");
      }
      const newItems = newGrid.innerHTML;
      wrapper.insertAdjacentHTML("beforeend", newItems);

      if (doc.getElementById("LoadMoreProgress")) {
        updateProgressLabel(responseHTML);
        updateProgressbar(currentPage, totalPages);
      }
    })
    .catch((error) => {
      console.error("Error loading items:", error);
      button.removeAttribute("disabled");
      button.classList.remove("loading");
    })
    .finally(() => {
      const canContinue =
        Number.isFinite(totalPages) && totalPages >= 1 && currentPage <= totalPages;
      if (canContinue) {
        const scrollData = document.querySelector(".infinite-scroll__data");
        if (scrollData && currentPage !== totalPages) {
          const nextUrlInput = scrollData.querySelector("input[data-next-url]");
          const currentPageInput = scrollData.querySelector(
            "input[data-current-page]"
          );
          const nextUrlScroll = getUrlWithoutPhcursor(rawValue, currentPage + 1);

          if (nextUrlInput) {
            nextUrlInput.dataset.nextUrl = nextUrlScroll;
            nextUrlInput.value = nextUrlScroll;
          }

          if (currentPageInput) {
            currentPageInput.dataset.currentPage = currentPage;
            currentPageInput.value = currentPage;
          }

          checkVisibility();
        }

        button.removeAttribute("disabled");
        button.classList.remove("loading");

        if (currentPage === totalPages) {
          button.remove();
        }
      } else {
        button.removeAttribute("disabled");
        button.classList.remove("loading");
      }
    });
}

function checkVisibility() {
  const spinnerList = document.querySelectorAll(".js-infinite-scroll");
  spinnerList.forEach((spinner) => {
    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadItems(spinner);
          sectionObserver.unobserve(entry.target);
        }
      });
    });

    sectionObserver.observe(spinner);
  });
}

function updateProgressLabel(html) {
  const count =
    new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("LoadMoreProgress")?.innerHTML || "";
  const container = document.getElementById("LoadMoreProgress");
  if (container) {
    container.innerHTML = count;
  }
}

function updateProgressbar(current, total) {
  const progressbar = document.getElementById("LoadMoreProgressBar");
  if (progressbar) {
    progressbar.style.width = `${(current / total) * 100}%`;
  }
}

function initLoadMore() {
  document.querySelectorAll(".js-load-more").forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    };
  });

  checkVisibility();
}

(function () {
  initLoadMore();
})();
